/**
 * API Configuration
 * Centralized configuration for API endpoints
 * 
 * In production: Replace with actual API URL from environment
 */

// Base API URL - configure via environment variable
export const API_BASE_URL =  'https://api.tendercentrix.com/api'
//  export const API_BASE_URL =  'http://localhost:4000/api';

/**
 * Request configuration defaults
 */
export const API_CONFIG = {
    headers: {
        'Content-Type': 'application/json',
    },
    credentials: 'include', // For cookie-based auth
}

/**
 * Create a configured fetch wrapper
 * This is the foundation for all API calls
 */
export async function apiFetch(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`

    const config = {
        ...API_CONFIG,
        ...options,
        headers: {
            ...API_CONFIG.headers,
            ...options.headers,
        },
    }

    // Add auth token if available
    const token = localStorage.getItem('admin_token')
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }

    const response = await fetch(url, config)

    // A 401 from the unauthenticated auth endpoints (bad password, bad/expired
    // 2FA code, etc.) is a normal user-facing failure, not a session expiry —
    // don't nuke the page for it, let the caller show the real error message.
    const isAuthEndpoint = endpoint.startsWith('/auth/')
    if (response.status === 401 && !isAuthEndpoint) {
        localStorage.removeItem('admin_user')
        localStorage.removeItem('admin_token')
        window.location.href = '/login'
    }

    if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Request failed' }))
        throw new Error(error.message || `HTTP ${response.status}`)
    }

    return response.json()
}

/**
 * API helper methods
 */
export const api = {
    get: (endpoint) => apiFetch(endpoint, { method: 'GET' }),
    post: (endpoint, data) => apiFetch(endpoint, { method: 'POST', body: JSON.stringify(data) }),
    put: (endpoint, data) => apiFetch(endpoint, { method: 'PUT', body: JSON.stringify(data) }),
    patch: (endpoint, data) => apiFetch(endpoint, { method: 'PATCH', body: JSON.stringify(data) }),
    delete: (endpoint) => apiFetch(endpoint, { method: 'DELETE' }),
}
